import classNames from 'classnames';

import { LocationDetail } from 'hooks/useGetLocations';
import LocationSearchResult from './LocationSearchResult';
import CurrentLocation from './CurrentLocation';
import { Icons } from '../common/icons/Icon';
import { useGeolocationContext } from 'providers/GeolocationProvider';

type LocationSearchResultsProps = {
  className?: string;
  locations?: LocationDetail[];
  historyLocations?: LocationDetail[];
  onSelect: () => any;
};

function LocationSearchResults({
  className,
  locations = [],
  historyLocations = [],
  onSelect,
}: LocationSearchResultsProps) {
  const { position } = useGeolocationContext();
  const isEmpty = locations.length + historyLocations.length === 0 && !position;
  if (isEmpty) return null;

  return (
    <div
      className={classNames('rounded-lg border border-slate-300/70 bg-white', className)}
      data-testid="location-search-results"
    >
      {locations.map((location) => {
        return (
          <LocationSearchResult
            key={location.id || location.name}
            iconName={Icons.LocationPin}
            location={location}
            onSelect={onSelect}
            save
          />
        );
      })}
      {historyLocations.map((location) => {
        return (
          <LocationSearchResult
            key={location.id || location.name}
            iconName={Icons.ClockRotateLeft}
            location={location}
            onSelect={onSelect}
            save
          />
        );
      })}
      <CurrentLocation onSelect={onSelect} />
    </div>
  );
}

export default LocationSearchResults;
